var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmediate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1792_32613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3757 -0.000488281H2.625C1.17525 -0.000488281 0 1.17477 0 2.62451V11.3752C0 12.825 1.17525 14.0002 2.625 14.0002H11.3757C12.8254 14.0002 14.0007 12.825 14.0007 11.3752V2.62451C14.0007 1.17477 12.8254 -0.000488281 11.3757 -0.000488281Z",
    fill: "#2E7D32"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75743 7.97234L4.46179 6.67669C4.03642 6.25133 3.68386 6.15433 3.42452 6.23555C3.32 6.26828 3.22916 6.32988 3.1541 6.41004C3.07618 6.49326 3.01429 6.59751 2.97069 6.71168C2.85172 7.02312 2.87373 7.39583 3.08123 7.60334L5.0058 9.52791C5.37495 9.89706 5.62401 10.0816 5.85408 10.0816C6.08458 10.0816 6.33357 9.8967 6.70236 9.52791L10.9188 5.31148C11.1263 5.10398 11.1483 4.73126 11.0293 4.41981C10.9857 4.30564 10.9238 4.20139 10.8459 4.11816C10.7708 4.038 10.68 3.97641 10.5755 3.94367C10.3162 3.86247 9.9636 3.95947 9.53824 4.38483L5.95074 7.97233L5.8541 8.06897L5.75743 7.97234Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1792_32613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmediate);
export default __webpack_public_path__ + "static/media/immediate.477780bcb69b55d1c9e296175dc8e7f5.svg";
export { ForwardRef as ReactComponent };